import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getLastResults, getDetailResults } from '../../../../apiservices/CasionApi';
import RefResultModal from '../../../casinoComponents/refResultModal';
import Teen1ResultBody from '../../../casinoComponents/refResultModal/Teen1ResultBody';
import { formatRefMatchTime } from '../../../../utils/refMatchTime';

/**
 * Last Result items for 1 CARD ONE-DAY (teen1) in the reference markup —
 * rendered inside `.casino-video-last-results`:
 *   win 1 → <span class="resulta">P</span>, 2 → <span class="resultb">D</span>, otherwise <span>T</span>
 * Click → full-page .loader-overlay while the round detail loads, then the reference result modal.
 */
const ResultTeen1 = ({ data = [], gameType }) => {
  const apiType = (gameType || 'teen1').toLowerCase().trim();
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(apiType);
        if (response?.data?.data?.res) {
          setLastResults(response.data.data.res.map((item) => ({ mid: item.mid, win: String(item.win) })));
        }
      } catch (error) {
        console.error('Error fetching last results:', error);
      }
    };
    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, [apiType]);

  const handleResultClick = async (item) => {
    if (!item?.mid) return;
    setLoading(true);
    try {
      const response = await getDetailResults(apiType, item.mid.toString());
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) {
        setDetailResult(t1);
        setShowModal(true);
      }
    } catch (error) {
      console.error('Error fetching detail results:', error);
    }
    setLoading(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDetailResult(null);
  };

  // API results; before they arrive, the feed's lrs ("P"/"D" or {mid, win}) as a fallback
  const items = lastResults.length > 0
    ? lastResults
    : (Array.isArray(data) ? data : []).map((r) =>
        typeof r === 'object' && r
          ? { mid: r.mid, win: String(r.win) }
          : { mid: null, win: r === 'P' ? '1' : r === 'D' ? '2' : String(r) }
      );

  return (
    <>
      {items.map((item, index) => {
        const cls = item.win === '1' ? 'resulta' : item.win === '2' ? 'resultb' : undefined;
        return (
          <span key={item.mid || index} className={cls} onClick={() => handleResultClick(item)}>
            {item.win === '1' ? 'P' : item.win === '2' ? 'D' : 'T'}
          </span>
        );
      })}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector('.page-content') || document.body)}
      <RefResultModal
        show={showModal && !loading && !!detailResult}
        onHide={handleCloseModal}
        title={`${detailResult?.ename || '1 CARD ONE-DAY'} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        <Teen1ResultBody t1={detailResult} />
      </RefResultModal>
    </>
  );
};

export default ResultTeen1;
